export const searchTypes = [
  {
    label: 'Asian',
    value: 'asian',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query', 'media_track_query' ],
    color: '#A78BFA',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'AFP (Agence France-Presse)',
    value: 'afp',
    fields: [],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#A78BFA',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Reuters',
    value: 'reuters',
    fields: [],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#FF8000',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Carma OCR Arabic',
    value: 'carma_ocr_arabic',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#7fa275',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Carma OCR English',
    value: 'carma_ocr_english',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#7fa275',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Carma OCR French',
    value: 'carma_ocr_french',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#7fa275',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Carma OCR Hebrew',
    value: 'carma_ocr_hebrew',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#7fa275',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Carma OCR Iran',
    value: 'carma_ocr_iran',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#7fa275',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Carma OCR Portuguese',
    value: 'carma_ocr_portuguese',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#7fa275',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Carma OCR Asian',
    value: 'carma_ocr_asian',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#7fa275',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Financial Times',
    value: 'financial_times',
    fields: [
      'locations', 'excludeLocations',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#7f7777',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Media Track Arabic',
    value: 'media_track_arabic',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#0896c2',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Media Track English',
    value: 'media_track_english',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#A78BFA',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Media Track French',
    value: 'media_track_french',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#A78BFA',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Media Track Broadcast',
    value: 'media_track_broadcast',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#A78BFA',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'CBS Automated (Carma Broadcast System Automated)',
    value: 'carma_broadcast',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#7fa275',
    allowMulti: false,
    allowTagLink: true
  },
  {
    label: 'CBS Curated (Carma Broadcast System Curated)',
    value: 'carma_broadcast_curation',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#7fb276',
    allowMulti: true,
    allowTagLink: true
  },  
  {
    label: 'Media Track Hebrew',
    value: 'media_track_hebrew',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#0896c2',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Media Track Iran',
    value: 'media_track_iran',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#0896c2',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Media Track Portuguese',
    value: 'media_track_portuguese',
    fields: [
      'locations',  'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#998f6e',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Mena Scraper',
    value: 'mena_scraper',
    fields: [
      'locations', 'excludeLocations',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'keywords'
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#7fa275',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'NLA',
    value: 'nla',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets', 
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#A78BFA',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Online',
    value: 'online',
    fields: [
      'includeMediaSubtypes', 'locations', 'excludeLocations',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
      'includeStates', 'excludeStates'
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#CC0066',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'Social Influencers',
    value: 'socials',
    fields: [
      'socialInfluencer',
      'includeInfluencers',
    ],
    queries: [ 'multi_provider_standard_query' ],
    color: '#00bbff',
    allowMulti: false,
    allowTagLink: true,
    isEnabledKeys: ['enable_social_influencers_searches']
  },
  {
    label: 'Online Paywall',
    value: 'online_paywall',
    fields: [
      'locations', 'excludeLocations',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
      'includeStates', 'excludeStates'
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#0896c2',
    allowMulti: true,
    allowTagLink: true
  },  
  {
    label: 'Google Alert',
    value: 'google_alert',
    fields: [
      'locations', 'excludeLocations',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
      'includeStates', 'excludeStates'
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#10B981',
    allowMulti: true,
    allowTagLink: true
  },  
  {
    label: 'Traditional (Print)',
    value: 'print',
    fields: [
      'categories', 'includeMediaSubtypes',
      'locations', 'excludeLocations', 'boolOutletCategories',
      'includeOutlets', 'excludeOutlets',
      'includeOutletGroups', 'excludeOutletGroups',
      'keywords'
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#22D3EE',
    allowTagLink: false
  },
  {
    label: 'Tass',
    value: 'tass',
    fields: [
      'locations', 'excludeLocations',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#F59E0B',
    allowMulti: true,
    allowTagLink: false
  },
  {
    label: 'eClips',
    value: 'eclips',
    fields: [
      'locations', 'excludeLocations',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#3366ff',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'TVEyes',
    value: 'tveyes',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query' ],
    color: '#0891B2',
    allowMulti: false,
    allowTagLink: false
  },
  {
    label: 'TVEyes Podcast',
    value: 'tveyes_podcast',
    fields: [
      'locations', 'excludeLocations',
      'includeOutlets', 'excludeOutlets',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeLanguages', 'excludeLanguages',
    ],
    queries: [ 'regex_query' ],
    color: '#089155',
    allowMulti: false,
    allowTagLink: false
  },
  {
    label: 'X (formerly Twitter)',
    value: 'twitter',
    fields: [
      'includeLanguages', 'excludeLanguages',
      'biolocations',
      'twitterFilter',
      'twitterMinFollowers',
      // 'deepSearchLocation',
      // 'locations',
    ],
    queries: [ /*executed by twitter */'regex_query',
     /*after filter with lucene on our side */'twitter_standard_query' ],
    color: '#83cda8',
    allowMulti: false,
    $isDisabled: true,
    allowTagLink: false
  },
  {
    label: 'Voice Interaction',
    value: 'voice_interaction',
    fields: [
      'locations', 'excludeLocations', 'includeMediaSubtypes',
      'includeOutletGroups', 'excludeOutletGroups',
      'includeOutlets', 'excludeOutlets',
    ],
    queries: [ 'regex_query', 'standard_query', 'user_query' ],
    color: '#10B981',
    allowMulti: true,
    allowTagLink: true
  },
  {
    label: 'X (formerly Twitter) v2',
    value: 'x_netfeedr',
    fields: [
      'locations', 'excludeLocations',
      'includeLanguages', 'excludeLanguages',
      'includeUsers', 'excludeUsers',
      'twitterFilter',
      'mustIncludeTerms', 'shouldIncludeTerms', 'mustExcludeTerms'
    ],
    queries: ['twitter_standard_query'],
    color: '#78a58e',
    allowMulti: false,
    allowTagLink: true
  },
  {
    label: 'X (formerly Twitter) v3',
    value: 'twitter_search_v3',
    fields: [
      'includeLanguages', 'excludeLanguages',
      'includeUsers', 'excludeUsers',
      'biolocations',
      'twitterFilter',
      'twitterMinFollowers'
    ],
    queries: ['regex_query', 'twitter_standard_query'],
    color: '#2f80ed',
    allowMulti: false,
    allowTagLink: true
  },
  {
    label: 'X (formerly Twitter) Channel',
    value: 'x_netfeedr_channel',
    fields: [
      'includeUsers',
      'twitterFilter'
    ],
    queries: ['twitter_standard_query'],
    color: '#78a58e',
    allowMulti: false,
    allowTagLink: true
  },
];

export const multiSyntaxSearch = {
  fields: [
    'locations', 'excludeLocations',
    'includeOutletGroups', 'excludeOutletGroups',
    'includeOutlets', 'excludeOutlets',
    'includeLanguages', 'excludeLanguages',
    'includeStates', 'excludeStates'
  ],
  queries: [ 'multi_provider_standard_query' ],
  color: '#DCF763'
}

export const tagCategoryType = {
  'Competitors': 'red',
  'People': '#754cf5',
  'Organizations': 'lightgreen',
  'Products': 'gray',
  'Places': 'lightblue',
}

export const query = {
  id: null,
  uid: null,
  project_id: null,
  twitter_api_id: null,
  search_type: "online",
  is_multi: false,
  name: "",
  description: "",
  synced_to_samsara: false,
  created_at: "",
  updated_at: "",

  // filters
  filters: {
    keywords: {
      key: 'keywords',
      values: {
        keywords: []
      }
    },

    categories: {
      key: 'categories',
      values: {
        categories: []
      }
    },

    social_influencer: {
      key: 'social_influencer',
      values: {
        social_influencer: [],
        include_influencer_group_ids: []
      }
    },

    locations: {
      key: 'locations',
      values: {
        locations: [],
        include_locations: [],
        exclude_locations: []
      }
    },

    states: {
      key: 'states',
      values: {
        include_states: [],
        exclude_states: []
      }
    },

    languages: {
      key: 'languages',
      values: {
        include_languages: [],
        exclude_languages: []
      }
    },

    outlet_groups: {
      key: 'outlet_groups',
      values: {
        outlet_group_ids: [],
        exclude_outlet_group_ids: []
      }
    },

    outlets: {
      key: 'outlets',
      values: {
        include_outlet_ids: [],
        exclude_outlet_ids: []
      }
    },

    media_subtypes: {
      key: 'media_subtypes',
      values: {
        media_subtypes: [],
      }
    },

    twitter_filters: { // need endpoint
      key: 'twitter_filters',
      values: {
        twitter_filters: ['-is:retweet', '-is:quote'],
      }
    },

    twitter_min_followers: {
      key: 'twitter_min_followers',
      values: {
        twitter_min_followers: 100,
      }
    },

    biolocations: {
      key: 'biolocations',
      values: {
        biolocations: []
      }
    },

    min_follower_biolocation: {
      key: 'min_follower_biolocation',
      values: {
        min_follower_biolocation: 100
      }
    },

    include_users: {
      key: 'include_users',
      values: {
        include_users: []
      }
    },
    exclude_users: {
      key: 'exclude_users',
      values: {
        exclude_users: []
      }
    },
    must_include_terms: {
      key: 'must_include_terms',
      values: {
        must_include_terms: []
      }
    },
    should_include_terms: {
      key: 'should_include_terms',
      values: {
        should_include_terms: []
      }
    },
    must_exclude_terms: {
      key: 'must_exclude_terms',
      values: {
        must_exclude_terms: []
      }
    }
  },

  // queries
  queries: {
    query: "",
    user_query: "",
    standard_query: "",
    regex_query: "",
  }
}

const queries = [
  {
    label: 'Lucene Query for Pipeline (Case Sensitive)',
    value: 'user_query'
  },
  {
    label: 'Lucene Query for Pipeline (Case Insensitive)',
    value: 'regex_query'
  },
  {
    label: 'Lucene Query Pattern (Do not break words by space)',
    value: 'standard_query'
  }
]

export const filterKeys = {
  social_influencer: {
    title: 'Social Influencer',
    color: '#00bbff',
  },
  locations: {
    title: 'Locations',
    color: '#cdbb83',
  },
  languages: {
    title: 'Languages',
    color: '#91a7ff'
  },
  outlets: {
    title: 'Outlets',
    color: '#b197fc',
  },
  outlet_groups: {
    title: 'Outlet Groups',
    color: '#C084FC',
  },
  categories: {
    title: 'Categories',
    color: '#b197fc',
  },
  sources: {
    title: 'Sources',
    color: '#748ffc',
  },
  organizations: {
    title: 'Organizations',
    color: '#80bfc5',
  },
  competitors: {
    title: 'Competitors',
    color: '#80a2c5',
  },
  people: {
    title: 'People',
    color: '#e097c5',
  },
  products: {
    title: 'Products',
    color: '#d77083',
  },
  media_subtypes: {
    title: 'Media Types',
    color: '#d77083',
  },
  twitter_filters: {
    title: 'X (formerly Twitter)',
    color: '#d77083',
  },
  provider_data: {
    title: 'Provider',
    color: '#d77083',
  },
  states: {
    title: 'States',
    color: '#d77083',
  },
  keywords: {
    title: 'Keywords',
    color: '#adb5bd',
  },
  users: {
    title: 'Users',
    color: '#adb5bd',
  }
}

export const groupQuery = {
  id: null,
  uid: null,
  name: "",
  description: "",
  created_at: "",
  updated_at: "",
  query: "",
}

export const tagSearchQuery = {
  id: null,
  uid: null,
  name: "",
  created_at: "",
  updated_at: "",
  category: "Competitors",
  is_private: false,
  synced_to_samsara: false,
  is_multi: false,
  
  // queries
  queries: {
    query: "",
    user_query: "",
    standard_query: "",
    regex_query: "",
  }
}

export const activityActions = {
  UPDATE: 'updated',
  CREATE: 'created',
  DESTROY: 'deleted'
}

export const queriesDisplayOrder = ['regex_query', 'standard_query', 'user_query'];

export const autocompleteOptionsOrder = ['operator', 'field', 'group', 'source_country'];

export const searchTermsCountLimit = 30;

export const twitterSearchesLimit = 400;